export default __webpack_public_path__ + "static/media/ng .dd63a6f8.png";